import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TriagemBanner from "@/components/landing/TriagemBanner";
import PartnersMarquee from "@/components/landing/PartnersMarquee";
import NossaHistoria from "@/components/landing/NossaHistoria";
import NossoImpacto from "@/components/landing/NossoImpacto";
import PilarCristao from "@/components/landing/PilarCristao";
import PilarSaude from "@/components/landing/PilarSaude";
import EnagaDestaque from "@/components/landing/EnagaDestaque";
import OutrosPilares from "@/components/landing/OutrosPilares";
import NossosProjetos from "@/components/landing/NossosProjetos";
import MissaoVisaoValores from "@/components/landing/MissaoVisaoValores";
import TransformandoVidas from "@/components/landing/TransformandoVidas";
import TriagemCounter from "@/components/landing/TriagemCounter";
import Donations from "@/components/landing/Donations";
import ParaOndeVai from "@/components/landing/ParaOndeVai";
import Momentos from "@/components/landing/Momentos";
import InstagramHub from "@/components/landing/InstagramHub";
import InstagramReels from "@/components/landing/InstagramReels";
import Lembrancas from "@/components/landing/Lembrancas";
import ProvaSocial from "@/components/landing/ProvaSocial";
import Parceiros from "@/components/landing/Parceiros";
import Localizacao from "@/components/landing/Localizacao";
import Contact from "@/components/landing/Contact";
import MobileDoarFab from "@/components/landing/MobileDoarFab";
import WhatsAppFab from "@/components/landing/WhatsAppFab";
import TriagemFab from "@/components/landing/TriagemFab";
import DonationModal from "@/components/landing/DonationModal";
import { DonationProvider } from "@/context/DonationContext";

export default function Landing() {
  return (
    <DonationProvider>
      <main data-testid="landing-root" className="overflow-x-hidden">
        <Navbar />
        <Hero />
        <TriagemBanner />
        <PartnersMarquee />
        <NossaHistoria />
        <NossoImpacto />
        <PilarCristao />
        <PilarSaude />
        <EnagaDestaque />
        <OutrosPilares />
        <NossosProjetos />
        <MissaoVisaoValores />
        <TransformandoVidas />
        <TriagemCounter />
        <ParaOndeVai />
        <Donations />
        <Momentos />
        <InstagramReels />
        <InstagramHub />
        <Lembrancas />
        <ProvaSocial />
        <Parceiros />
        <Localizacao />
        <Contact />
        <MobileDoarFab />
        <WhatsAppFab />
        <TriagemFab />
        <DonationModal />
      </main>
    </DonationProvider>
  );
}
